/**
 * SHOPKO — Bloque global de confianza en páginas de producto.
 *
 * [2026-09 SHOPKO PREPAGO] Actualizado al modelo 100% pago online:
 *   - Se eliminaron las menciones a pago contra entrega.
 *   - No se promete envío gratis: el despacho se calcula en el checkout.
 *   - No se inserta en landings construidas con la Landing Master SHOPKO
 *     (elementos [data-shopko-lm]), que ya incluyen su propia zona de confianza.
 *
 * Solo inserta HTML estático de solo lectura. No modifica checkout, carrito,
 * Starken, medios de pago, píxel de Meta ni apps.
 */
(function () {
  'use strict';

  var BADGES_HTML =
    '<div class="shopko-tb" role="note" aria-label="Compra segura en SHOPKO">' +
    '<ul class="shopko-tb__list">' +
    '<li class="shopko-tb__item"><span class="shopko-tb__icon" aria-hidden="true">🔒</span><span class="shopko-tb__text">Pago online seguro</span></li>' +
    '<li class="shopko-tb__item"><span class="shopko-tb__icon" aria-hidden="true">💳</span><span class="shopko-tb__text">Débito y crédito</span></li>' +
    '<li class="shopko-tb__item"><span class="shopko-tb__icon" aria-hidden="true">🚚</span><span class="shopko-tb__text">Despachos a todo Chile con seguimiento</span></li>' +
    '</ul></div>';

  var NOTE_HTML =
    '<p class="shopko-cta-note">Pago 100% online y seguro antes del despacho. ' +
    'Ingresa tu dirección en el checkout para conocer el valor exacto del despacho.</p>';

  function isLandingMaster() {
    return !!document.querySelector('[data-shopko-lm]');
  }

  function insertAfter(referenceNode, html) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var node = wrapper.firstElementChild;
    if (referenceNode.parentNode) {
      referenceNode.parentNode.insertBefore(node, referenceNode.nextSibling);
    }
    return node;
  }

  function addBadges() {
    if (document.querySelector('.shopko-tb')) return;
    var price = document.querySelector('.product-page-price');
    if (!price) return;
    insertAfter(price, BADGES_HTML);
  }

  function addCtaNote() {
    if (document.querySelector('.shopko-cta-note')) return;
    var anchor =
      document.querySelector('.product-form__buttons') ||
      document.querySelector('.sticky-atc-container');
    if (!anchor) return;
    insertAfter(anchor, NOTE_HTML);
  }

  function run() {
    if (isLandingMaster()) return;
    addBadges();
    addCtaNote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
